import axios from 'axios';
import env from '../../config';
import { Client } from '@opanuj/shared/types';
import { useMutation } from '@tanstack/react-query';

const useClientsAdd = () => {
	return useMutation({
		mutationFn: (clientData: Partial<Client>) => {
			return axios.post(env.endpoints.clientsAdd, clientData, {
				headers: {
					'Content-Type': 'application/json',
				},
			});
		},
	});
};

export default useClientsAdd;
